import React from 'react';
import { Input } from '@bedrock/components';
import { ListSearch } from '@bedrock/icons-react';
import type { TriggerComponent } from '../types';

/**
 * Input 触发器变体。
 * 还原 BProjectCodeSelect 的 isInput 模式：
 * 只读 Input + 搜索图标 suffix，点击触发弹窗。
 */
export const InputVariant: TriggerComponent = ({
  displayValue,
  onClick,
  disabled,
  placeholder = '请选择',
  triggerProps,
}) => {
  const { className, style, ...rest } = (triggerProps ?? {}) as Record<string, unknown>;

  return (
    <Input
      readOnly
      value={displayValue || ''}
      onClick={onClick}
      disabled={disabled}
      placeholder={placeholder}
      suffix={<ListSearch />}
      className={`cursor-pointer ${(className as string) ?? ''}`}
      style={style as React.CSSProperties}
      {...rest}
    />
  );
};
